.ux-autosuggest-item {
  @include font(light);

  background-color: $color-white;
  border-bottom: solid 1px $color-gray-25;
  color: $color-gray-copy;
  display: flex;

  &__image {
    background-color: $color-gray-10;
    background-size: cover;
    height: 75px;
    width: 75px;
  }

  &__text-container {
    padding: 15px;
  }

  &--slim &__text-container {
    padding: 5px 15px;
  }

  &--slim:hover {
    background-color: $color-gray-10;
  }

  &--slim {
    border-bottom: solid 1px $color-gray-10;
  }

  &__highlight {
    color: $color-green;
  }

  &__subline {
    text-transform: uppercase;
  }
}
